import React, { useState, useEffect } from 'react'
import {
	Row,
	Col,
	Card,
	FormControl,
	Button,
} from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
	faChevronLeft,
	faChevronRight,
	faEye,
} from '@fortawesome/free-solid-svg-icons'
import styles from './EmployersDetails.module.scss'
import 'react-day-picker/lib/style.css'
import { useNavigate } from 'react-router-dom'
import ReactPaginate from 'react-paginate'
import axios from 'axios'
import PropTypes from 'prop-types'

const EmployersJobList = ({ companyId, setJobAggregate, setIsFirst }) => {
	const navigate = useNavigate()

	const [isLoading, setIsLoading] = useState(true)
	const [jobs, setJobs] = useState<any[]>([])
	const [currentPage, setCurrentPage] = useState(1)

	const [page, setPage] = useState('')
	const [filterPage, setFilterPage] = useState('')
	const [pageSize, setPageSize] = useState(10)
	const [toPage, setToPage] = useState<number>(0)
	const [pageCount, setPageCount] = useState(0)

	const getCompaniesJob = async () => {
		setIsLoading(true)
		try {
			const res = await axios.get(process.env.REACT_APP_ROUTE_GET_JOB as string + `?page=${currentPage}&pageSize=${pageSize}&companyId=${companyId}`)

			setJobs(res.data.jobs)
			setPageCount(Math.ceil(res.data.jobAggregate / pageSize))
			setJobAggregate(res.data.jobAggregate)
			setIsLoading(false)
			if (page === '') {
				setIsFirst(false)
			}
		} catch (err) {
			return console.log(err)
		}
	}

	useEffect(() => {
		if (companyId !== '') {
			getCompaniesJob()
		}
	}, [currentPage])

	useEffect(() => {
		const toNum = () => {
			if (page === '') {
				setToPage(0)
			} else {
				const temp = parseInt(page)
				setToPage(temp - 1)
			}
		}
		toNum()
	}, [page])

	const handlePageClick = (event: { selected: number }) => {
		setCurrentPage(event.selected + 1)
	}

	const numbersOnly = (val: string) => {
		const numsCheck = new RegExp('^[0-9]{1,6}$')//6 digits only
		if (numsCheck.test(val) || val === '') {
			setFilterPage(val)
		}
		if (parseInt(val) > pageCount) {
			setFilterPage(pageCount.toString())
		}
	}

	const submitPageNumber = () => {
		setCurrentPage(parseInt(filterPage))
		setPage(filterPage)
	}

	return (
		<div>
			<Card className={`${styles.tabsCard} p-0`}>
				{isLoading ? (
					<div className='text-center mt-3'>
						<p>Loading</p>
					</div>
				) : (
					jobs?.length > 0 ?
						jobs.map((job, i) => {
							return (
								<div key={i} className='border-top p-4'>
									<Row>
										<Col md={10}>
											<h6 className={`fw-bold mb-0 ${styles.title}`} onClick={() => navigate(`/jobs/${job.id}`)}>{job.title}</h6>
											{job.salaries && job.salaries.map((salary: any, i: number) => {
												return (
													<div key={i}>
														<small>
															{salary.min > 0 ? `$${salary.min}` : ''}
															{salary.min > 0 && salary.max > 0 ? ' - ' : ''}
															{salary.max > 0 ? `$${salary.max}` : ''} {salary.salaryType}
														</small>
													</div>
												)
											})}
											<Row>
												<Col className='mt-3'>
													<span className={`badge ${styles.customBadge}`} style={{ backgroundColor: '#EDF3FA', border: '1px solid #5B7493', color: '#5B7493' }}>
														{job.application} Applicant
													</span>
													<span className={`badge ${styles.customBadge}`} style={{ backgroundColor: '#FFF3ED', border: '1px solid #FE9465', color: '#FE9465' }}>
														{job.pending_application ? job.pending_application : 0} Pending
													</span>
													<span className={`badge ${styles.customBadge}`} style={{ backgroundColor: '#E5F5FF', border: '1px solid #1CA8FF', color: '#1CA8FF' }}>
														{job.shortlisted_application ? job.shortlisted_application : 0} Shortlisted
													</span>
													<span className={`badge ${styles.customBadge}`} style={{ backgroundColor: '#EBFFF1', border: '1px solid #2BCB5C', color: '#2BCB5C' }}>
														{job.successful_application ? job.successful_application : 0} Successful
													</span>
													<span className={`badge ${styles.customBadge}`} style={{ backgroundColor: '#FFF2F2', border: '1px solid #FE6565', color: '#FE6565' }}>
														{job.unsuccessful_application ? job.unsuccessful_application : 0} Unsuccessful
													</span>
												</Col>
											</Row>
										</Col>
										<Col className='d-flex align-items-center'>
											<Button
												className={styles.filterBtn}
												onClick={() => navigate(`/jobs/${job.id}`)}
											>
												<FontAwesomeIcon icon={faEye} />
												<span className='ps-2'>Details</span>
											</Button>
										</Col>
									</Row>
								</div>
							)
						})
						: <div className='border-top p-4'>
							No jobs
						</div>
				)}
			</Card>

			<Row style={{ marginTop: '20px' }}>
				<Col />
				<Col>
					<ReactPaginate
						containerClassName={styles.pagination}
						previousClassName="page-item"
						nextLinkClassName="page-link"
						// activeClassName="active"
						activeLinkClassName={styles.paginationActive}
						pageClassName="page-item"
						pageLinkClassName="page-link"
						previousLinkClassName="page-link"
						nextClassName="page-item"
						breakLinkClassName="page-link"
						breakClassName="page-item"
						previousLabel={<FontAwesomeIcon icon={faChevronLeft} />}
						pageCount={pageCount}
						onPageChange={handlePageClick}
						nextLabel={<FontAwesomeIcon icon={faChevronRight} />}
						pageRangeDisplayed={3}
						marginPagesDisplayed={3}
						breakLabel="..."
						forcePage={toPage}
					// renderOnZeroPageCount={null}
					/>
				</Col>
				<Col style={{ display: 'flex', justifyContent: 'flex-end' }}>
					<span style={{ fontSize: '14px', color: '#5B7493', paddingTop: '5px' }}>Go to page</span>
					<FormControl
						style={{ width: '15%', display: 'inline-block', marginLeft: '15px', marginRight: '15px', height: '33px' }}
						onChange={e => {
							numbersOnly(e.target.value)
						}}
						value={filterPage}
					/>
					<Button onClick={submitPageNumber} variant='primary' className={styles.cusBtn}>
						Go
					</Button>
				</Col>
			</Row>
		</div>
	)
}

EmployersJobList.propTypes = {
	companyId: PropTypes.any.isRequired,
	setJobAggregate: PropTypes.func.isRequired,
	setIsFirst: PropTypes.func.isRequired,
}

export default EmployersJobList